var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_4523)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42688,
    y: 5,
    width: 75.0199,
    height: 64,
    rx: 4.43,
    fill: "white",
    stroke: "#D2DDE9",
    strokeOpacity: 0.5,
    strokeWidth: 0.464259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9815 27H10.294L13.3665 18.2727H15.3182L18.3949 27H16.7074L14.3764 20.0625H14.3082L11.9815 27ZM12.0369 23.5781H16.6392V24.848H12.0369V23.5781ZM19.5444 27V18.2727H22.8171C23.4876 18.2727 24.0501 18.3977 24.5046 18.6477C24.962 18.8977 25.3072 19.2415 25.5401 19.679C25.7759 20.1136 25.8938 20.608 25.8938 21.1619C25.8938 21.7216 25.7759 22.2187 25.5401 22.6534C25.3043 23.0881 24.9563 23.4304 24.4961 23.6804C24.0359 23.9276 23.4691 24.0511 22.7958 24.0511H20.6268V22.7514H22.5827C22.9748 22.7514 23.2958 22.6832 23.5458 22.5469C23.7958 22.4105 23.9805 22.223 24.0998 21.9844C24.2219 21.7457 24.283 21.4716 24.283 21.1619C24.283 20.8523 24.2219 20.5795 24.0998 20.3438C23.9805 20.108 23.7944 19.9247 23.5415 19.794C23.2915 19.6605 22.9691 19.5938 22.5742 19.5938H21.1254V27H19.5444ZM28.848 18.2727V27H27.267V18.2727H28.848Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 3,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 27)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 2,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 33)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 3,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 38)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 2,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 44)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 2,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 22)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 28,
    height: 2,
    rx: 0.928519,
    transform: "matrix(-1 0 0 1 75 17)",
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42688 9.43C4.42688 6.98338 6.41026 5 8.85688 5H75.1432C77.5898 5 79.5732 6.98338 79.5732 9.43V12.0838H4.42688V9.43Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2102,
    cy: 8.42347,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#FF889D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9871,
    cy: 8.42347,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#FBE597"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5285,
    cy: 8.42347,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#6EEFBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4523",
    x: 0.194702,
    y: 0.767883,
    width: 99.4841,
    height: 88.4642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.497656 0 0 0 0 0.619531 0 0 0 0 0.8125 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4523",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.14ec999664b4eae4921e7a40e967d70e.svg";
export { ForwardRef as ReactComponent };